import React from 'react'
import Svg from './Svg'
import { useBrand } from 'contexts/BrandContext'

const Logo = (
  props // @TODO Reimplment CSS
) => {
  const { logo } = useBrand()

  return (
    <div {...props} style={{ width: '190px' }}>
      {logo ? (
        <img src={logo.src} alt={logo.alt} className="w-full h-auto" />
      ) : (
        <Svg />
      )}
    </div>
  )
}

export default Logo
